import type { NodePropertySchema } from '../../../types/node-properties';

/**
 * Manual Trigger Node Schema
 * Based on n8n's ManualWorkflowTrigger node
 * 
 * This node has NO configurable properties - it simply triggers the workflow
 * when the user clicks "Test Workflow" or manually executes.
 */
const schema: NodePropertySchema = {
  nodeType: 'manual-trigger',
  version: '1.0.0',
  
  properties: [
    // Manual trigger has no configurable properties
    // It simply provides empty data to start the workflow
  ],
  
  metadata: {
    author: 'Evo E2E Team',
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.manualworkflowtrigger/'
  }
};

export default schema;
